var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiloUpFillArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33535 3.21861L1.75942 6.79461L0.81662 5.85181L6.00202 0.666342L11.1875 5.85181L10.2447 6.79461L6.66869 3.21861V11.333H5.33535V3.21861Z",
    fill: "#3ED179"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiloUpFillArrow);
export default __webpack_public_path__ + "static/media/hilo-up-fill-arrow.79baa3ddd1b7d445c6599f7200d33c0d.svg";
export { ForwardRef as ReactComponent };